// src/features/owner/sections/system/OwnerSettingsSection.tsx — prototype platform settings form.
import { useState } from 'react';
import { useOwnerAction } from '@/hooks/useOwnerAction';
import { Button } from '@/ui';
import { OwnerPanel } from '../../components';

export function OwnerSettingsSection() {
  const action = useOwnerAction();
  const [name, setName] = useState('TruXSocial');
  return (
    <OwnerPanel title="Platform Settings (prototype, not yet wired)">
      <label style={{ display: 'block', marginBottom: 8 }}>
        Platform name
        <input
          value={name}
          onChange={(e) => setName(e.target.value)}
          style={{ display: 'block', marginTop: 4, width: '100%', maxWidth: 360 }}
        />
      </label>
      <Button variant="primary" onClick={() => action.logAction('save-settings', 'platform', name)}>
        Save
      </Button>
    </OwnerPanel>
  );
}
